import gql from "graphql-tag";

export default gql`
	query countGroups($group_name: String) {
		countGroups(groupName: $group_name)
	}
`;
